import styled from "styled-components";

const FaqSc = styled.div`
  margin: 10px;
  padding: 5px;
  height: 90vh;
  border-radius: 10px;
  /* fallback for old browsers */
  width: 100vw;
  /* Chrome 10-25, Safari 5.1-6 */
  position: absolute;
  top: 45px;

  .container {
    display: flex;
    flex-direction: column;
    width: 100vw;
    word-break: break-all;
    justify-content: center;
    align-items: center;
  }
  .queries-navbar {
    position: fixed;
  }
  .bloc-tabs {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100vw;
    padding: 5px;
  }
  .tabs {
    text-align: center;
    width: 50%;
    cursor: pointer;
    position: relative;
    border-style: none;
  }

  .active-tabs {
    color: blue;
  }
  .content-tabs {
    flex-grow: 1;
  }
  .content {
    padding: 10px;
    width: 100%;
    height: 100%;
    display: none;
  }

  .active-content {
    display: flex;
    flex-direction: column;
    width: 80vw;
    gap: 20px;
  }
  .xbi4er-button {
    display: flex;
    align-items: center;
    width: 80vw;
  }
  .faq-main-container {
    display: flex;
    justify-content: space-between;
    text-align: center;
  }
  .faq-content-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
  }
  .heading-container {
    width: 98vw;
    display: flex;
    justify-content: space-between;
  }
  .inside-faq {
    display: flex;
    justify-content: space-between;
    text-align: center;
    margin-left: 35px;
  }
  table {
    font-family: arial, sans-serif;
    width: 100%;
    margin: 30px auto;
    max-width: 90vw;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-collapse: collapse;
  }
`;

export default FaqSc;
